import { forwardRef, type ReactNode, type CSSProperties } from 'react';
import { css, cx } from '@mildang/styled-system/css';

const rootStyle = css({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  //@ts-ignore
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 'var(--text-truncate-line-clamp)',
});

export interface TextTruncateProps {
  children: ReactNode;
  /** 표시할 최대 줄 수. 이 줄 수를 넘는 내용은 잘리고 말줄임표(…)로 표시됨(-webkit-line-clamp). */
  lineClamp: number;
  className?: string;
}

export const TextTruncate = forwardRef<HTMLSpanElement, TextTruncateProps>(
  ({ children, lineClamp, className, ...others }, ref) => {
    return (
      <span
        ref={ref}
        className={cx(rootStyle, className)}
        style={{ '--text-truncate-line-clamp': lineClamp } as CSSProperties}
        {...others}
      >
        {children}
      </span>
    );
  },
);

export default TextTruncate;

TextTruncate.displayName = 'TextTruncate';
